<template>
  <b-modal
    v-model="showModal"
    title="CARGA DE SALDO INICIAL DE DÍAS LIBRES"
    modal-class="modal-primary"
    size="xl"
    hide-footer
    no-close-on-backdrop
    scrollable
    @hidden="$emit('hidden')"
  >
    <b-alert show variant="warning" class="p-1">
      <feather-icon icon="AlertTriangleIcon" class="mr-25" />
      El saldo que cargues aquí es el punto de partida del acumulado: los meses
      anteriores al periodo elegido dejan de contarse. Se registra un único
      saldo inicial por conductor; si vuelves a cargarlo, reemplaza al anterior.
    </b-alert>

    <b-row class="mb-1 align-items-end">
      <b-col md="3">
        <b-form-group label="Periodo de corte" class="mb-0">
          <b-form-input v-model="periodoCorte" type="month" />
        </b-form-group>
      </b-col>
      <b-col md="5">
        <b-form-group label="Buscar conductor" class="mb-0">
          <b-form-input
            v-model="busqueda"
            placeholder="Nombre o documento..."
            @keyup.enter="getConductores"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-button variant="outline-primary" @click="getConductores">
          <feather-icon icon="SearchIcon" /> Buscar
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          :disabled="!cargados.length"
          @click="guardar"
        >
          Guardar {{ cargados.length }} saldo(s)
        </b-button>
      </b-col>
    </b-row>

    <b-table
      small
      responsive
      sticky-header="50vh"
      :items="conductores"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="Sin conductores"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" />
        </div>
      </template>

      <template #cell(personal_name)="data">
        <span>{{ data.value | capitalize }}</span>
        <br />
        <span style="opacity: 0.6">
          {{ data.item.code }} · {{ data.item.documento }}
        </span>
      </template>

      <template #cell(regimen)="data">
        <b-badge v-if="data.value" variant="light-primary">
          {{ data.value }}
        </b-badge>
        <b-badge v-else variant="light-danger">SIN RÉGIMEN</b-badge>
      </template>

      <template #cell(saldo_actual)="data">
        <b-badge variant="light-secondary">{{ data.value }}</b-badge>
      </template>

      <template #cell(saldo_inicial)="data">
        <b-form-input
          v-model.number="data.item.saldo_inicial"
          type="number"
          step="0.5"
          size="sm"
          style="width: 110px"
          placeholder="0"
        />
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import DiasLibresReportService from "@/views/monitoring/views/dias-libres/services/dias-libres-report.service.js";

export default {
  props: {
    periodo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: true,
      isBusy: false,
      conductores: [],
      busqueda: "",
      periodoCorte: this.periodo,
      fields: [
        { key: "personal_name", label: "Conductor" },
        { key: "regimen", label: "Régimen", class: "text-center" },
        { key: "saldo_actual", label: "Saldo calculado", class: "text-center" },
        { key: "saldo_inicial", label: "Saldo real", class: "text-center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    cargados() {
      return this.conductores.filter(
        (item) => item.saldo_inicial !== null && item.saldo_inicial !== ""
      );
    },
  },
  created() {
    this.getConductores();
  },
  methods: {
    async getConductores() {
      try {
        this.isBusy = true;
        const { data } = await DiasLibresReportService.getReporte({
          fecha_base: `${this.periodoCorte}-01`,
          meses: 1,
          search_txt: this.busqueda,
          page: 1,
          perpage: 500,
        });

        this.conductores = data.data.data.map((item) => ({
          personal_id: item.personal_id,
          personal_name: item.personal_name,
          code: item.code,
          documento: item.documento,
          regimen: item.regimen,
          saldo_actual: item.saldo_actual,
          saldo_inicial: null,
        }));
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },

    async guardar() {
      const { isConfirmed } = await this.showConfirmSwal(
        `¿Cargar el saldo inicial de ${this.cargados.length} conductor(es)?`,
        `El acumulado de cada uno se contará desde ${this.periodoCorte}.`
      );
      if (!isConfirmed) return;

      try {
        this.addPreloader();
        const { data } = await DiasLibresReportService.cargarSaldoInicial({
          periodo: this.periodoCorte,
          id_usuario: this.currentUser.id,
          saldos: this.cargados.map((item) => ({
            personal_id: item.personal_id,
            cantidad: item.saldo_inicial,
            motivo: "Carga de saldo inicial de días libres",
            sustento: `Cargado el ${moment().format("YYYY-MM-DD")}`,
          })),
        });
        this.showToastSuccess(data.message);
        this.$emit("saved");
      } catch (error) {
        this.showToastError(
          error.response?.data?.message || "No se pudo cargar el saldo inicial"
        );
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
